import { Credentials } from "src/models/instantiateClass";
import { BscNftCreateCollection } from "src/models/modelsBscNft/BscNftCreateCollection";
import { BscNftMint } from "src/models/modelsBscNft/BscNftMint";
import { BscNftSmartContractVerify } from "src/models/modelsBscNft/BscNftSmartContractVerify";
import { BscGetAbi } from "src/models/modelsBscSmartContract/BscGetAbi";
import { BscGetAbiFunctions } from "src/models/modelsBscSmartContract/BscGetAbiFunctions";
import { BscGetTxStatus } from "src/models/modelsBscSmartContract/BscGetTxStatus";
import { BscTokenCreate } from "src/models/modelsBscToken/BscTokenCreate";
import { BscTokenSmartContractVerify } from "src/models/modelsBscToken/BscTokenSmartContractVerify";
import { BscTokenTransfer } from "src/models/modelsBscToken/BscTokenTransfer";

import { TokenSmartContractInteraction } from "src/models/utilities/tokenContractInteraction";
import { axiosRequest } from "./axiosCore";
import { extractValues } from "./extractValues";

 export const bscTokenCreate = async (payload: BscTokenCreate, initialize: Credentials) => {
    return await axiosRequest('/bsc/token/mint', payload, initialize);
 }
 
 export const bscTokenTransfer = async (payload: BscTokenTransfer, initialize: Credentials) => {
     return await axiosRequest('/bsc/token/transfer', payload, initialize);
  }

  export const bscNftCreateCollection = async (payload: BscNftCreateCollection, initialize: Credentials) => {
    return await axiosRequest('/bsc/nft/createCollection', payload, initialize);
 }
 
 export const bscNftMint = async (payload: BscNftMint, initialize: Credentials) => {
     return await axiosRequest('/bsc/nft/mintNft', payload, initialize);
  }

  export const bscNftSmartContractVerify = async (payload: BscNftSmartContractVerify, initialize: Credentials) => {
    return await axiosRequest('/bsc/nft/smartContract/verify', payload, initialize);
 }

 export const bscTokenSmartContractVerify = async (payload: BscTokenSmartContractVerify, initialize: Credentials) => {
    return await axiosRequest('/bsc/token/smartContract/verify', payload, initialize);
 }

 export const bscGetAbi = async (payload: BscGetAbi, initialize: Credentials) => {
    return await axiosRequest('/bsc/smartContract/getAbi', payload, initialize);
 }
 export const bscGetAbiFunctions = async (payload: BscGetAbiFunctions, initialize: Credentials) => {
    return await axiosRequest('/bsc/smartContract/getAbiFunctions', payload, initialize);
 }

 export const bscGetTxStatus = async (payload: BscGetTxStatus, initialize: Credentials) => {
    return await axiosRequest('/bsc/transactions/status', payload, initialize);
 }

 export const bscTokenSmartContractInteraction = async (payload: TokenSmartContractInteraction, initialize: Credentials) => {
  const parameters = extractValues(payload.parameters)
  const modifiedPayload = {
      ...payload,
      parameters
  } 
   return await axiosRequest('/bsc/token/buildContractInteraction', modifiedPayload, initialize);
}